import React from 'react'
import styles from './Slide.module.scss'

const Slide = ({ url, alt, noPhoto, className = '' }) => {
  const [newSource, setSource] = React.useState(url)

  if (url !== newSource) {
    setSource(url)
  }

  return (
    <img
      className={className || styles.slide}
      loading="lazy"
      alt={alt}
      src={newSource}
      onError={() => setSource(noPhoto)}
    />
  )
}

export default Slide
